
export default ({ showType, closeType }) => {
  const INITIAL_STATE = {
    visible: false,
    message: null,
    title: null
  };

  return (state = INITIAL_STATE, action) => {
    switch(action.type) {
      case closeType:
        return {
          ...state,
          visible: false
        };

      case showType:
        return {
          ...state,
          visible: true,
          message: action.message,
          title: action.title
        };

      default:
        return state;
    }
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/infoMaker.js
 **/